/** @packageDocumentation Common types used in drawing. */


/** A point on the Carthesian plane. */
export type Point = {
  /** Abscissa. */
  x: number,
  /** Ordinate. */
  y: number
}

export function Point(x: number, y: number): Point {
  return { x, y }
}


/** A vector on the Carthesian plane. */
export type Vector = {
  x: number,
  y: number
}

export function Vector(x: number, y: number): Vector {
  return { x, y }
}

export class VectorUtil {

  public static scale(v: Vector, s: number): Vector {
    return Vector(v.x * s, v.y * s)
  }

  public static add(a: Vector, b: Vector): Vector {
    return Point(a.x + b.x, a.y + b.y)
  }

  public static subtract(a: Vector, b: Vector): Vector {
    return Point(a.x - b.x, a.y - b.y)
  }

}


/** A width and a height. */
export type Size = {
  width: number,
  height: number
}

export function Size(width: number, height: number): Size {
  return { width, height }
}

export class SizeUtil {

  public static fromMetricsActual(metrics: TextMetrics): Size {
    return Size(metrics.width, metrics.actualBoundingBoxAscent + metrics.actualBoundingBoxDescent)
  }

  public static fromMetricsFont(metrics: TextMetrics): Size {
    return Size(metrics.width, metrics.fontBoundingBoxAscent + metrics.fontBoundingBoxDescent)
  }

  public static toVector(size: Size): Vector {
    return Vector(size.width, size.height)
  }

  public static shrink(s: Size, amount: number): Size {
    return Size(s.width - amount, s.height - amount)
  }

  public static grow(s: Size, amount: number): Size {
    return Size(s.width + amount, s.height + amount)
  }

  public static scale(s: Size, factor: number): Size {
    return Size(s.width * factor, s.height * factor)
  }

}
